import { mediaItems } from '@/mocks/homeData';

export default function Media() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            视频实锤
          </h2>
          <p className="text-sm text-foreground-500 font-body">
            网红翻车现场视频合集，有图有真相，每一帧都是实锤
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className={`group flex flex-col rounded-xl bg-background-100 border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2 sm:flex-row' : ''
              }`}
            >
              <div
                className={`relative overflow-hidden shrink-0 ${
                  i === 0 ? 'sm:w-1/2 h-44 sm:h-auto' : 'w-full h-40'
                }`}
              >
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.style.display = 'none';
                    }
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                    <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-1.5 py-0.5 bg-foreground-900/70 text-background-50 text-xs rounded font-label">
                  {item.duration}
                </span>
              </div>
              <div className={`p-4 ${i === 0 ? 'sm:w-1/2 flex flex-col justify-center' : ''}`}>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading leading-snug line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}